import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator, SelectField, TextField, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsconfig from './aws-exports';

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import CharSelect from './pages/CharSelect';
import Policy from './pages/Policy';
import Settings from './pages/Settings';
import Timeline from './pages/Timeline';
import MyRecipes from './pages/MyRecipes';
import RecipeCreate from './pages/RecipeCreate';
import RecipeDetail from './pages/RecipeDetail';
import RecipeEdit from './pages/RecipeEdit';

Amplify.configure(awsconfig);

const CHARACTERS_STAND = [
  '/assets/yukito/yukito_stand.png',
  '/assets/sable/sable_stand.png',
];

const components = {
  SignIn: {
    Header() {
      return (
        <div style={{ position: 'relative', overflow: 'hidden', padding: '30px 20px 10px', textAlign: 'center', background: '#0f1117', margin: '-1px -1px 0' }}>
          <img src={CHARACTERS_STAND[0]} alt="" style={{
            position: 'absolute', top: 0, left: '-10px',
            height: '160px', opacity: 1, pointerEvents: 'none',
            objectFit: 'contain', objectPosition: 'top', zIndex: 0,
          }} onError={e => { e.target.style.display = 'none'; }} />
          <img src={CHARACTERS_STAND[1]} alt="" style={{
            position: 'absolute', top: 0, right: '-10px',
            height: '160px', opacity: 1, pointerEvents: 'none',
            objectFit: 'contain', objectPosition: 'top', zIndex: 0,
          }} onError={e => { e.target.style.display = 'none'; }} />
          <h1 style={{ color: '#fff', fontSize: '18px', fontWeight: '900', margin: '0 0 4px', fontFamily: "'Noto Serif JP', serif", position: 'relative', zIndex: 1 }}>
            🥗 ゆきけん
          </h1>
          <p style={{ color: '#aaa', fontSize: '12px', margin: 0, position: 'relative', zIndex: 1 }}>
            白峰 雪人の栄養分析研究所
          </p>
        </div>
      );
    },
  },
  SignUp: {
    Header() {
      return (
        <div style={{ padding: '20px 20px 10px', textAlign: 'center', background: '#0f1117' }}>
          <h1 style={{ color: '#fff', fontSize: '18px', fontWeight: '900', margin: '0 0 4px', fontFamily: "'Noto Serif JP', serif" }}>
            🥗 ゆきけん
          </h1>
          <p style={{ color: '#aaa', fontSize: '12px', margin: 0 }}>白峰 雪人の栄養分析研究所</p>
        </div>
      );
    },
    FormFields() {
      const { validationErrors } = useAuthenticator();
      return (
        <>
          <Authenticator.SignUp.FormFields />
          <TextField label="ニックネーム" name="nickname" placeholder="あなたが呼んでほしい名前" required />
          <SelectField label="性別" name="gender" placeholder="選択してください" required
            errorMessage={validationErrors.gender} hasError={!!validationErrors.gender}>
            <option value="男性">男性</option>
            <option value="女性">女性</option>
            <option value="未回答">未回答</option>
          </SelectField>
        </>
      );
    },
  },
  VerifyUser: {
    Header() { return null; },
    Footer() {
      const { skipVerification } = useAuthenticator();
      React.useEffect(() => { skipVerification(); }, [skipVerification]);
      return null;
    },
  },
};

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <Authenticator components={components} signUpAttributes={['email', 'gender']}>
      {({ signOut, user }) => (
        <Router>
          <div style={{ backgroundColor: '#f4f7f9', minHeight: '100vh' }}>
            <Header onMenuClick={() => setIsSidebarOpen(true)} user={user} />
            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} signOut={signOut} />
            <main>
              <Routes>
                <Route path="/" element={<Home user={user} />} />
                <Route path="/characters" element={<CharSelect />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/settings" element={<Settings user={user} />} />
                <Route path="/timeline" element={<Timeline />} />
                <Route path="/myrecipes" element={<MyRecipes />} />
                <Route path="/recipe/create" element={<RecipeCreate />} />
                <Route path="/recipe/:id" element={<RecipeDetail />} />
                <Route path="/recipe/edit/:id" element={<RecipeEdit />} />
              </Routes>
            </main>
          </div>
        </Router>
      )}
    </Authenticator>
  );
}

export default App;
